import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { getAllRegions, RegionResponse } from '@apis/region';

export const useRegionList = () => {
  const queryOptions: UseQueryOptions<PageResponse<RegionResponse>, Error> = {
    queryKey: ['regions'],
    queryFn: () => {
      return getAllRegions();
    },
  };
  return useQuery(queryOptions);
};
